require('./location-display/location-display.scss');
var BaseViews = require('./base');
var Button = require('treeline-shared-components/button.js');
var SpinnerButton = require('treeline-shared-components/spinner-button');
var LocationMap = require('./locations-map');
var LocationsList = require('./locations-list');
require('geolocator');


var LocationMapCTA = BaseViews.LayoutView.extend({
    _expandedMap: false,
    template: require('./location-display/location-map-cta.html'),
    className: 'fmcy-location-map-cta',
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                _appChannel: null
            }
        );
    },
    ui: {
      detectedLocationResults: '.fmcy-location-map-detected-location-results',
      detectedLocationResultsText: '.fmcy-location-map-detected-location-results-text',
      detectLocationCTA: '.fmcy-location-map-cta-inner'
    },
    regions : {
      useLocationButtonRegion: '.fmcy-location-display-detect-location-button-region'
    },
    displayClosestLocationDistance: function (model, distance) {
      this.ui.detectLocationCTA.hide();
      this.ui.detectedLocationResultsText.html('The closest location to you is <span class="fmcy-location-map-detected-location-results-text-location">' + model.get('name') + '</span> which is <span class="fmcy-location-map-detected-location-results-text-location-distance">' + Math.round(distance) + 'KM</span> away.')
      this.ui.detectedLocationResults.show();
    },
    _renderDetectLocationButton: function () {
      var self = this;
      var detectLocationButton = new SpinnerButton.SpinnerButton({
          label: 'FIND CLOSEST STORE TO YOUR LOCATION',
          enabled: true,
          theme: Button.THEMES.PRIMARY,
          onClickedCallback: function () {
            detectLocationButton.toggleSpinner(true);
            detectLocationButton.toggledEnabledState(false);
            var options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumWait: 10000,     // max wait time for desired accuracy
                maximumAge: 0,          // disable cache
                desiredAccuracy: 30,    // meters
                fallbackToIP: true     // fallback to IP if Geolocation fails or rejected
            };
            geolocator.locate(options, function (err, location) {
                if (err) return console.log(err);
                detectLocationButton.toggleSpinner(false);
                detectLocationButton.toggledEnabledState(true);
                self.trigger('detected:location', location);
            });
          }
      });
      this.useLocationButtonRegion.show(detectLocationButton);
    },
    onRender: function () {
        BaseViews.LayoutView.prototype.onRender.call(this);
        this._renderDetectLocationButton();
        this.ui.detectedLocationResults.hide();
    }
});


var LocationDisplay = BaseViews.LayoutView.extend({
    _expandedMap: false,
    template: require('./location-display/location-display.html'),
    className: 'fmcy-plugin-bootstrap fmcy-location-display container-fluid',
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                _appChannel: null,
                _menuState: null,
                referrer: null,
                message: null
            }
        );
    },
    regions : {
      changeLocationButtonRegion: '.fmcy-location-display-change-location-button-region',
      fmcyLocationMapRegion: '.fmcy-location-map-region',
      fmcyLocationMapCtaRegion: '.fmcy-location-map-cta-region',
      fmcyLocationMapTabRegion: '.fmcy-location-map-tab-region',
      fmcyLocationMapListRegion: '.fmcy-location-map-list-region'
    },
    ui : {
      expandedRow: '.fmcy-location-display-expanded-row'
    },
    serializeData: function () {
      this.model = this.options._appChannel.request('get:filter:location:details');
      var dayOfTheWeek = moment().format('dddd').toLowerCase();
      var isOpen = this.model.get('hours_' + dayOfTheWeek + '_open');
      var startTime = this.model.get('hours_' + dayOfTheWeek + '_start_time');
      var endTime = this.model.get('hours_' + dayOfTheWeek + '_end_time');

      var hours;
      if (isOpen === '1' && startTime !== null && startTime !== '' && endTime !== null && endTime !== '') {
        hours = startTime.replace(':00', '') + ' to ' + endTime.replace(':00', '');
      } else {
        hours = 'Closed';
      }

      return {
        name: this.model.get('name'),
        line_1: this.model.get('line_1'),
        city: this.model.get('city'),
        hours: hours,
        imageUrl: this.model.get('image_medium_url')
      }
    },
    _renderMapCTA: function () {
      var self = this;
      this._locationMapCTA = new LocationMapCTA();
      this._locationMapCTA.on('detected:location', function (location) {
        if (self.location_map) {
          self.location_map.addUserLocationToMap(location);
        }
      });
      this.fmcyLocationMapCtaRegion.show(this._locationMapCTA);
      this.options._appChannel.trigger('active:view:add','locationselectmap');
    },
    _hideMapCTA: function () {
      this.fmcyLocationMapCtaRegion.empty();
      this.options._appChannel.trigger('active:view:remove','locationselectmap');
    },
    _renderLocationMap: function () {
      var self = this;
      this._expandedMap = true;
      this.ui.expandedRow.height($(window).height());
      this.location_map = new LocationMap({
        _appChannel: this.options._appChannel,
        adjustForMenuBar: false,
        topPos: 51,
        leftPos: 450,
        botPos: 75
      });

      this.location_map.on('map:feature:selected', function (model) {
        self._hideLocationMap();
        self._hideMapCTA();
        self.options._appChannel.trigger('location:selected', model.get('slug'), self.options.referrer);
        self.trigger('close:clicked');
      });

      this.location_map.on('map:closest:point:user:detected', function (model, distance) {
        if (self._locationMapCTA) {
          self._locationMapCTA.displayClosestLocationDistance(model, distance);
        }
      });

      this.location_map.on('close:clicked', function () {
        self._hideLocationMap();
        self._hideMapCTA();
        self.options._appChannel.trigger('active:view:remove','locationselectmap');
        self.trigger('close:clicked');
      });

      this.fmcyLocationMapRegion.show(this.location_map);
      this.options._appChannel.trigger('active:view:add','locationselectmap');
    },
    _hideLocationMap: function () {
      this._expandedMap = false;
      if (this.ui.expandedRow !== null) {
        this.ui.expandedRow.height(0);
      }
      this.options._appChannel.trigger('active:view:remove','locationselectmap');
      this.fmcyLocationMapRegion.empty();
    },
    _renderChangeLocationButton: function () {
      var self = this;
      var changeLocationButton = new Button.Button({
          label: 'CHANGE LOCATION',
          enabled: true,
          theme: Button.THEMES.DEFAULT,
          onClickedCallback: function () {
            self._renderLocationMap();
            self._renderMapCTA();
          }
      });
      this.changeLocationButtonRegion.show(changeLocationButton);
    },
    _renderLocationList: function() {
      var self = this;
      this.locationsList = new LocationsList({
        collection: this.options._appChannel.request('get:locations')
      });
      this.locationsList.on('item:clicked', function(model) {
        if (self.location_map) {
          self.location_map.trigger('map:feature:selected', model);
        }
      });
      this.fmcyLocationMapListRegion.show(this.locationsList);
    },
    _renderLocationTabs: function() {
        var self = this;
        if (self._tabs) {
            return;
        }
        self._tabs = new (require('treeline-shared-components/tabs'))({
            style: 'tabs',
            tabs: [
                {
                    id: 'list',
                    labelText: 'List'
                },
                {
                    id: 'map',
                    labelText: 'Map'
                },
            ]
        });
        self._tabs.on('tab:clicked', function (tabModel) {
          if (tabModel.id == 'map') {
            self.fmcyLocationMapListRegion.$el.hide();
            if (self.location_map) {
              self.location_map.adjustMapContainerPosition(null, 0);
              self.location_map.mapToFeaturesExtent();
            }
          } else {
            self.fmcyLocationMapListRegion.$el.show();
            if (self.location_map) {
              self.location_map.adjustMapContainerPosition(null, 450);
            }
          }
        });
        this._tabs.setActiveTabById('list');
        self.fmcyLocationMapTabRegion.show(self._tabs);
    },
    onRender: function () {
        //this._renderChangeLocationButton();
        this._renderLocationTabs();
        this._renderLocationList();
        this._renderLocationMap();
        this._renderMapCTA();
    }
});
module.exports = LocationDisplay;



/** WEBPACK FOOTER **
 ** ./assets/js/common/location-display.js
 **/